import { create } from "zustand";

type ToastKind = "info" | "success" | "error";

interface ToastState {
  message: string | null;
  kind: ToastKind;
  show: (message: string, kind?: ToastKind) => void;
  hide: () => void;
}

export const useToast = create<ToastState>((set) => ({
  message: null,
  kind: "info",
  show: (message, kind = "info") => {
    set({ message, kind });
    setTimeout(() => set({ message: null }), 5000);
  },
  hide: () => set({ message: null }),
}));

export function ToastHost() {
  const { message, kind, hide } = useToast();
  if (!message) return null;
  const tone =
    kind === "error"
      ? "bg-red-600 text-white"
      : kind === "success"
        ? "bg-emerald-600 text-white"
        : "bg-slate-800 text-white";
  return (
    <div className={`fixed bottom-4 right-4 max-w-md rounded-md px-4 py-3 shadow-lg ${tone}`}>
      <div className="flex items-start gap-3">
        <div className="text-sm">{message}</div>
        <button onClick={hide} className="text-xs opacity-80 hover:opacity-100">
          dismiss
        </button>
      </div>
    </div>
  );
}
